// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"0416e6c0","386":"e8168a01","456":"be699209"}[chunkId] + ".chunk.js";
};